import React from 'react';
import { Link, useParams } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@eluve/components';

export const OutputTemplateBreadcrumbs: React.FC = () => {
  const { outputTemplateId } = useParams() as {
    outputTemplateId?: string;
  };

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/admin/output-templates?isActive=true">
              Output Templates
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {outputTemplateId && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={`/admin/output-templates/${outputTemplateId}`}>
                  Output Template Details
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
